export class ResponseResults {
    public status = null;
    public results = null;
    public errors = [];

    setStatus(status) {
        this.status = status;
    }

    setResults(results) {
        this.results = results;
    }

    setErrors(errors: any = []) {
        if (Array.isArray(errors)) {
            this.errors.push(...errors);
        } else {
            this.errors.push(errors);
        }
    }

    getStatus() {
        return this.status;
    }

    getResults() {
        return this.results;
    }

    getErrors() {
        return this.errors;
    }
}
